import { ChoiceType } from "../types/choiceType";
import { getCurrentTextTranslation } from "./getCurrentTextTranslation";

const getChoiceTitle = (answerChoice: ChoiceType) => {
  return getCurrentTextTranslation(answerChoice?.textTranslations);
};

export default getChoiceTitle;
